var $068c9f18677c69da$exports = {};
$068c9f18677c69da$exports = {
    "valid": `\u{412}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D}`
};


export {$068c9f18677c69da$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
